/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Clear_ButtonInputs */

const en_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clear`)
};

const fr_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Effacer`)
};

const de_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klar`)
};

const it_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiaro`)
};

const ru_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Прозрачный`)
};

const es_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

const zh_cn2_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`清除`)
};

const ja_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`クリア`)
};

const hi_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्पष्ट`)
};

const pt_pt2_markers_clear_button = /** @type {(inputs: Markers_Clear_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Claro`)
};

/**
* | output |
* | --- |
* | "Clear" |
*
* @param {Markers_Clear_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_clear_button = /** @type {((inputs?: Markers_Clear_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Clear_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_clear_button(inputs)
	if (locale === "de") return de_markers_clear_button(inputs)
	if (locale === "it") return it_markers_clear_button(inputs)
	if (locale === "ru") return ru_markers_clear_button(inputs)
	if (locale === "es") return es_markers_clear_button(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_clear_button(inputs)
	if (locale === "ja") return ja_markers_clear_button(inputs)
	if (locale === "hi") return hi_markers_clear_button(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_clear_button(inputs)
	return en_markers_clear_button(inputs)
});